module.exports = __webpack_public_path__ + "media/images/edion/inside_1-e474a2e1cb342f57ed54c2a2c4c4fa25.png";